exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-45 {\n  width: 47.5%; }\n\n.full {\n  width: 100% !important; }\n\n.mail-chip {\n  float: right;\n  color: white; }\n  .mail-chip.invalid {\n    background-color: #ff6e40;\n    border-color: #ff6e40; }\n  .mail-chip.valid {\n    background-color: #4b81b0;\n    border-color: #4b81b0; }\n\n.mb-15 {\n  margin-bottom: 15px; }\n\n.ml-15 {\n  margin-left: 15px; }\n\nmd-radio-button {\n  margin-right: 30px; }\n\n@media (max-width: 767px) {\n  .mb-media {\n    margin-bottom: 15px; } }\n\n.add-cuit {\n  position: absolute;\n  top: 31.5px;\n  right: 30px;\n  transform: scale(1.1);\n  z-index: 10; }\n\n.cuit-container {\n  margin-bottom: 20px; }\n\n.fade-in-error {\n  font-weight: bold;\n  font-size: 14px;\n  animation-name: show;\n  animation-duration: 0.3s;\n  animation-timing-function: ease-out;\n  animation-fill-mode: forwards; }\n\n@keyframes show {\n  0% {\n    opacity: 0;\n    transform: translateY(-10px); }\n  100% {\n    opacity: 1;\n    transform: translateY(0px); } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/edit-usuario/edit-usuario.component.scss
// module id = ../../../../../src/app/components/cuentas/usuarios/edit-usuario/edit-usuario.component.scss
// module chunks = 0